<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-height="965px"
    :max-width="isOsStlye.maxWidth"
  >
    <v-card id="videoMeetingCreateDialog">
      <div class="dialog-container">
        <div class="dialog-header">
          <h3 class="popup-title">영상회의 개설</h3>
          <div class="header-btn" style="margin-right: 30px;">
          </div>
        </div>
        <div class="dialog-body">
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">제목</div>
            </div>
            <div class="dialog-contents">
              <input
                type="text"
                style="font-size: 12px"
                placeholder="필수 입력"
                v-model="meeting.title"
              />
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">일시</div>
            </div>
            <div class="dialog-date-contents" style="position: relative">
              <div style="width: 104px; display: flex; flex-direction: row; align-items: center;">
                <label style="display: flex; align-items: center;">
                  <input
                      type="checkbox"
                      class="form-control"
                      style="margin-right: 5px;"
                      name="a"
                      v-model="meeting.immediateMeeting"
                    />
                    즉시회의
                </label>
              </div>

              <date-picker
                :disabled="isTimeFixed || meeting.immediateMeeting"
                :disabled-date="notBeforeToday"
                v-model="meeting.startDate"
                @change="changeDate"
                format="YYYY.MM.DD"
                value-type="format"
                :lang="lang"
                style="
                  width: 140px;
                  height: 45px;
                  margin-right: 15px;
                  font-size: 13px;
                  cursor: pointer;
                "
              ></date-picker>
              <select
                class="formbox-time-select"
                v-model="meeting.startTime"
                @change="changedstartTime"
                :disabled="isTimeFixed || meeting.immediateMeeting"
                style="margin-right: 5px"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                >
                  {{ timeData }}
                </option>
              </select>
              <span style="font-size: 12px; margin-right: 5px">~</span>
              <select
                class="formbox-time-select"
                v-model="meeting.endTime"
                @change="changedendTime"
                :disabled="isTimeFixed || meeting.immediateMeeting"
              >
                <option
                  v-for="timeData in meetingTimeList"
                  :key="timeData"
                  :value="timeData"
                >
                  {{ timeData }}
                </option>
              </select>
            </div>
          </div>

          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row attendee-row">
            <div style="width: 45%; display: flex; align-items: center">
              <div class="dialog-title">
                <div class="dot-btn">&nbsp;</div>
                <div class="pl-2">참석자</div>
              </div>
              <div>
                <input
                  type="text"
                  class="select-input cursor-pointer"
                  style="font-size: 15px; width: 160px"
                  placeholder="선택 사항"
                  @click="openMeetingInvitaionDialog()"
                  :value="meeting.attendeesString"
                  readonly
                />
              </div>
            </div>
            <div style="width: 46%">
              <div style="display: flex; justify-content: end">
                <div
                  class="dialog-title"
                  style="margin-left: 10px; width: 170px"
                >
                  <div class="dot-btn">&nbsp;</div>
                  <div class="pl-2">레이아웃</div>
                </div>

                <input
                  type="text"
                  style="margin-left: 10px"
                  class="select-input cursor-pointer"
                  @click="openMeetingLayoutDialog()"
                  v-bind:style="{ display: isInputLayout }"
                  placeholder="선택사항"
                  readonly
                />

                <img
                  class="fix-layout-img"
                  :src="`${meeting.layoutFixSeatList.selectedLayoutImage}`"
                  v-bind:style="{ display: isLayout }"
                  @click="openMeetingLayoutDialog()"
                />
              </div>
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">회의실</div>
            </div>
            <div class="dialog-contents">
              <input
                type="text"
                style="font-size: 15px; width: 60%;"
                placeholder="회의실 추가"
                :disabled="meeting.immediateMeeting"
                @click="openMeetingConferenceDialog"
                :value="meeting.selectedConferenceRoomString"
                readonly
              />
              <button style="height: 45px;" @click="openConferenceRoomsList()">회의실 예약현황</button>
            </div>
          </div>
          <div class="dialog-line-flex">
            <div class="dialog-hr-line"></div>
          </div>
          <div class="dialog-row">
            <div class="dialog-title">
              <div class="dot-btn">&nbsp;</div>
              <div class="pl-2">부가기능</div>
            </div>
            <div
              class="dialog-public-contents"
              style="flex-direction: column; align-items: start"
            >
              <div
                style="display: flex; flex-direction: row; align-items: center"
              >
                <div>
                  <label class="custom-label">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                       v-model="meeting.meetingLog"
                      :disabled="meeting.meetingLogEn || meeting.conferenceRoomActive || meeting.exMeeting"
                    />
                    <span style="margin-left: 5px;">스마트회의록</span>
                  </label>
                </div>

                <!-- 실시간 자막 -->
                <div style="margin-left:20px;">
                  <label class="custom-label">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.meetingLogEn"
                      :disabled="meeting.meetingLog || meeting.conferenceRoomActive || meeting.exMeeting"
                    />
                    <span style="margin-left: 5px;">스마트회의록(영문)</span>
                  </label>
                </div>
                <div style="margin-left:20px;">
                  <label class="custom-label">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.exMeeting"
                      :disabled="isDisabled"
                    />
                    <span style="margin-left: 5px;">스마트 단말기 전용</span>
                  </label>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  margin-top: 10px;
                "
              >
                <label class="custom-label">
                  <input
                    type="checkbox"
                    class="form-control"
                    name="a"
                    v-model="meeting.allPublicMeeting"
                  />
                  <span style="margin-left: 5px;">전체 공개회의</span>
                </label>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <label class="custom-label" style="margin-left: 15px;">
                    <input
                      type="checkbox"
                      class="form-control"
                      name="a"
                      v-model="meeting.meetingPublicType"
                    />
                    <span style="margin-left: 5px;">비밀번호</span>
                  </label>
                  
                  <input
                    :style="{ display: isPrivate }"
                    type="password"
                    placeholder="비밀번호를 입력하세요"
                    class="select-input"
                    style="margin-left: 12px; width: 180px"
                    v-model="meeting.password"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="is-ipad" style="height: 50px"></div>
          <div class="dialog-footer">
            <button class="noIconButton" @click="close">취소</button>
            <button class="btnPrimary" @click="createMeeting">개설</button>
          </div>
        </div>
      </div>
    </v-card>

    <meeting-conference-dialog
      :dialog="meetingConferenceDialog.dialog"
      :meetingInfo="meeting"
      :conferenceRooms="meetingConferenceDialog.conferenceRooms"
      :closeDialog="closeMeetingConferenceDialog"
      @selectedConferenceRooms="selectedConferenceRooms"
    />

    <meeting-invitaion-dialog
      :dialog="meetingInvitaionDialog.dialog"
      :exMeeting="exMeeting"
      :attendeesInfo="meetingInvitaionDialog.attendees"
      :closeMeetingInvitaionDialog="closeMeetingInvitaionDialog"
    />

    <!-- 레이아웃 -->
    <meeting-layout-dialog
      :dialog="meetingLayoutDialog.dialog"
      :attendees="meeting.attendees"
      :meeetingFixSeatList="meeting.layoutFixSeatList.fixSeatList"
      :selectLayoutCode="meeting.layoutFixSeatList.selectedLayoutCode"
      :conferenceRoomActive="meeting.conferenceRoomActive"
      @selectedFixSeatList="selectedFixSeatList"
      @closeMeetingLayoutDialog="closeMeetingLayoutDialog"
    />

    <conference-agree-dialog
      :dialog="conferenceAgreeDialog.dialog"
      :closeDialog="closeConferenceAgreeDialog"
    />
  </v-dialog>
</template>
<script>
import Util from '@/util';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import MeetingCreate from '@/components/meeting/MeetingCreate';
/* import MeetingTypeDialog from '@/components/popup/MeetingTypeDialog'; */
import MeetingConferenceDialog from '@/components/popup/MeetingConferenceDialog';
import moment from 'moment';
import timezone from 'moment-timezone';
import MeetingInvitaionDialog from '@/components/popup/MeetingInvitaionDialog';
import BookmarkMeetingDialog from '@/components/popup/BookmarkMeetingDialog';
import AddBookmarkMeetingDialog from '@/components/popup/AddBookmarkMeetingDialog';
import GuideLogDialog from '@/components/popup/GuideLogDialog';
import RecLogDialog from '@/components/popup/RecLogDialog';
import MeetingLayoutDialog from '@/components/popup/MeetingLayoutDialog';
import ConferenceAgreeDialog from '@/components/popup/ConferenceAgreeDialog';

export default {
  filters: {
    conferenceDayFilter: function (day) {
      if (day === null) {
        return moment().format('YYYY / MM / DD');
      } else {
        return moment(day).format('YYYY / MM / DD');
      }
    },
    conferenceTimeFilter: function (time) {
      return moment(time).format('HH시 mm분');
    },
    textLengthOverCut(txt, len, lastTxt) {
      if (len === '' || len === null) {
        len = 5;
      }
      if (lastTxt === '' || lastTxt === null) {
        lastTxt = '...';
      }
      console.log(txt.length);
      console.log(len);
      if (txt.length > len) {
        txt = txt.substr(0, len) + lastTxt;
        console.log(txt);
      }
      return txt;
    },
  },
  components: {
    MeetingCreate,
    DatePicker,
    /* MeetingTypeDialog, */
    MeetingConferenceDialog,
    MeetingInvitaionDialog,
    MeetingLayoutDialog,
    BookmarkMeetingDialog,
    AddBookmarkMeetingDialog,
    ConferenceAgreeDialog,
    GuideLogDialog,
    RecLogDialog,
  },
  props: [
    'dialog',
    'closeDialog',
    'isTimeFixed',
    'isRoomSelectable',
    'isAdminPage',
  ],
  data() {
    return {
      /* meeting 데이터 */
      meeting: {
        creator: {
          email: null,
          empNum: null,
        },
        title: null,
        immediateMeeting: false,
        startDate: new Date().toISOString().substr(0, 10),
        startTime: null,
        endTime: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        conferenceRooms: [],
        conferenceRoomActive: false,
        selectedConferenceRoomString: null,
        selectedConferenceRoomArr: [],
        meetingLog: false,
        meetingLogEn: false,
        allPublicMeeting: false,
        meetingPublicType: false,
        password: null,
        roomOption: null,
        exMeeting: false,
        roomIds: [],
        layoutFixSeatList: {
          isLayout: false,
          selectedLayoutCode: '',
          selectedLayoutImage: '',
          fixSeatList: [],
        },
        resultFixSeat: [],
      },
      isDisabled: false,
      lang: {
        days: ['일', '월', '화', '수', '목', '금', '토'],
        months: [
          '1월',
          '2월',
          '3월',
          '4월',
          '5월',
          '6월',
          '7월',
          '8월',
          '9월',
          '10월',
          '11월',
          '12월',
        ],
        yearFormat: 'YYYY년',
        monthFormat: 'MM월',
        // the calendar title of month before year
        monthBeforeYear: false,
      },
      pickrFormat: 'YYYY.MM.DD',
      max: 4,
      minDate: new Date().toISOString().substr(0, 10),
      startDate: new Date().toISOString().substr(0, 10),
      isHelpActive: 'none',

      startTime: null,
      endTime: null,
      loading: true,
      attendeesString: null,
      selectedConferenceRoomString: null,
      meetingBookmarkImage: '/static/seoul/img/bookmark_off.png',
      meetingBookmarkActive: false,
      meetingLogActive: false,
      isOsStlye: {
        maxWidth: '670px',
        marginLeft: 0,
      },
      meetingTypeDialog: {
        dialog: false,
        attendees: [],
      },
      meetingConferenceDialog: {
        dialog: false,
        conferenceRooms: [],
      },
      meetingLayoutDialog: {
        dialog: false,
      },
      meetingInvitaionDialog: {
        dialog: false,
        attendees: [],
      },
      conferenceAgreeDialog: {
        dialog: false,
      },
      bookmarkMeetingDialog: {
        dialog: false,
      },
      addBookmarkMeetingDialog: {
        dialog: false,
        meetingInfo: {},
      },
      guideLogDialog: {
        dialog: false,
      },
      recLogDialog: {
        dialog: false,
      },
      addBookmarkMeetingBtn: false,
      layoutFixSeatList: {
        selectedLayoutCode: null,
        selectedLayoutImage: null,
      },
      isPrivate: 'none',
      meetingType: 'general',
      conferenceRoomActive: false,
      meetingPublicType: false,
      isActive: 'none',
      isRoomActive: 'none',
      isActiveStartTime: 'none',
      isInputLayout: '',
      isLayout: 'none',
      guideLog: null,
      recLog: null,
      exMeeting: false,
      meetingLog: null,
      agreeConference: null,
      meetingBanner: false,
      bannerPosition: 'bannerTop',
      meetingBannerActive: 'none',

      defaultMeeting: {
        title: null,
        startDate: null,
        startTime: null,
        endTime: null,
        conferenceRoomActive: false,
        meetingLog: false,
        allPublicMeeting: false,
        meetingPublicType: false,
        password: null,
        email: null,
        startDtime: null,
        endDtime: null,
        attendees: [],
        meetingRoom: null,
        meetingRoomId: null,
        roomIds: [],
      },
      editedMeetingInfo: {},

      error: null,

      repeatSetting: false,
      meetingTimeList: [],
      selectedConferenceRoom: null,
      selectedConferenceRoomArr: [],
      guideLogContents: null,
      recLogContents: null,
    };
  },
  computed: {
    nowHour() {
      let hh = moment().format('HH');
      let mm = moment().format('mm');

      let setHour = '';

      if (mm < 30) {
        setHour = moment().format('YYYY-MM-DDTHH:mm:ss');
      } else {
        setHour = moment().add('1', 'h').format('YYYY-MM-DDTHH:00:00');
      }

      return setHour;
    },
    reserveHour() {
      let time = this.meeting.startTime;
      if (time !== null) {
        if (time !== '') {
          let hh = time.split('T')[1].split(':')[0];
          let mm = time.split('T')[1].split(':')[1].split(':')[0];

          let setHour = '';
          if (mm === 30) {
            hh = parseInt(hh, 10) + 1;
            setHour = moment().format('YYYY-MM-DDT' + hh + ':00:ss');
          } else {
            setHour = moment()
              .add('30', 'm')
              .format('YYYY-MM-DDT' + hh + ':30:ss');
          }

          return setHour;
        }
      }
    },
  },
  watch: {
    dialog: {
      handler(val) {
        if (val) {
          this.editedMeetingInfo = Object.assign({}, this.meetingInfo);
          this.loading = false;
          this.initMeeting();
        }
      },
    },
    guideLog() {
      if (this.guideLog === true) {
        this.guideLogDialog.dialog = true;
      } else {
        this.guideLogDialog.dialog = false;
      }
    },
    recLog() {
      if (this.recLog === true) {
        this.recLogDialog.dialog = true;
      } else {
        this.recLogDialog.dialog = false;
      }
    },
    'meeting.conferenceRoomActive'() {
      this.meetingLog = false;

      if (this.meeting.conferenceRoomActive === true) {
        this.isRoomActive = '';
        this.meetingLayoutDialog.selectLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutImage = null;
        this.isInputLayout = '';
        this.isLayout = 'none';
      } else {
        this.isRoomActive = 'none';
        this.meetingLayoutDialog.selectLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutCode = null;
        this.layoutFixSeatList.selectedLayoutImage = null;
        this.isInputLayout = '';
        this.isLayout = 'none';

        this.meetingConferenceDialog.conferenceRooms = [];
      }
    },

    'meeting.meetingPublicType' () {
      if (this.meeting.meetingPublicType === true) {
        this.isPrivate = '';
      } else {
        this.isPrivate = 'none';
        this.meeting.password = null;
        this.meeting.meetingPublicType = false;
      }
    },
    'meeting.immediateMeeting'(val) {
      /* 즉시회의 여기서 작업하시면 됩니다. */
      this.immediateChange(val);
      this.editedMeetingInfo.selectStartTime = moment().format('YYYY.MM.DD');
    },
    meetingBanner() {
      this.meetingBanner
        ? (this.meetingBannerActive = '')
        : (this.meetingBannerActive = 'none');
    },
  },
  methods: {
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    initMeeting() {
      /* meetingData 초기화 */
      this.initMeetingData();

      /* 시간 초기화 */
      this.initTimeData();
      let os = Util.getOS();

      if (os.indexOf('window') !== -1) {
        this.isOsStlye.maxWidth = '750px';
      }
    },
    initTimeData() {
      this.meetingTimeList = [];
      let meetingInterval = 10;
      let time = moment();
      let startDate = moment(time.format('YYYY.MM.DD'));
      let endDate = time.clone().add(1, 'day').format('YYYY.MM.DD');
      while (startDate.format('YYYY.MM.DD') < endDate) {
        this.meetingTimeList.push(startDate.format('HH:mm'));
        startDate = startDate.add(meetingInterval, 'minutes');
      }

      let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);

      this.meeting.startTime = nearestFuture.format('HH:mm');
      this.meeting.endTime = nearestFuture.add(30, 'minutes').format('HH:mm');
    },
    async createMeeting () {
      if (this.meeting.startTime === '즉시회의') {
        this.meeting.startTime = moment(new Date()).format('HH:mm');
        this.meeting.status = 's';
        this.meeting.immediateMeeting = true;
      }
      const startDtime = moment
        .tz(
          `${this.meeting.startDate.replace(/\./g, '-')} ${
            this.meeting.startTime
          }`,
          'Asia/Seoul'
        )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');

      const endDtime = moment
        .tz(
          `${this.meeting.startDate.replace(/\./g, '-')} ${
            this.meeting.endTime
          }`,
          'Asia/Seoul'
        )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');

      this.meeting.startDtime = startDtime;
      this.meeting.endDtime = endDtime;

      /* #### 미팅 예약 시 필수 데이터 체크 하는 부분 #### */
      if (this.meeting.title === null) {
        Util.snackBarOpen('회의제목을 추가해주세요.', 'error');
        return;
      }

      if (
        this.meeting.startDtime >= this.meeting.endDtime &&
        !this.meeting.immediateMeeting
      ) {
        if (this.meeting.startDtime === this.meeting.endDtime) {
          Util.snackBarOpen(
            '시작일시와 종료일시가 같을 수 없습니다. 정확한 정보를 입력해주세요',
            'error'
          );
          return;
        } else {
          Util.snackBarOpen(
            '시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요',
            'error'
          );
          this.error =
            '시작일시가 종료일시보다 늦습니다. 정확한 정보를 입력해주세요';
          return;
        }
      }

      if (this.meeting.meetingPublicType === true) {
        if (this.meeting.password === null) {
          Util.snackBarOpen('비밀번호를 입력하시기 바랍니다.', 'error');
          return;
        }
      }

      if (
        moment(new Date()).format('YYYY.MM.DD') === this.meeting.startDate &&
        moment(new Date()).format('HH:mm') >= this.meeting.startTime &&
        !this.meeting.immediateMeeting
      ) {
        Util.snackBarOpen(
          '지난 시간입니다. 현재 시간 이후로 예약이 가능합니다.',
          'error'
        );
        return;
      }


      let isFixed = false;
      if (this.meeting.layoutFixSeatList.selectedLayoutCode !== null) {
        if (
          this.meeting.layoutFixSeatList.fixSeatList &&
          this.meeting.layoutFixSeatList.fixSeatList.length > 0
        ) {
          isFixed = true;
        }

        this.meeting.roomOption = Util.getSaehaLayoutOption(
          this.meeting.layoutFixSeatList.selectedLayoutCode,
          isFixed,
          this.meeting.layoutFixSeatList.fixSeatList
        );
      }

      
      if (this.meeting.selectedConferenceRoomArr.length !== 0) {
        this.meeting.conferenceRooms = this.meeting.selectedConferenceRoomArr.map(el => el.cuse_eqpmt_seq);
      }

      if (this.meeting.attendees) {
        this.meeting.attendees = this.meeting.attendees.map(el => el.empNum);
      }

      /* 미팅 생성 및 실행되는 부분 */
      let createUrl = this.meeting.exMeeting
        ? '/api/v1/meetings/ksd/createExMeeting'
        : '/api/v1/meetings/createMeeting';
        
      this.$http.post(createUrl, this.meeting).then((response) => {
        let result = response.data;
        if (result) {
          Util.snackBarOpen('영상회의 예약 완료', 'success');
          this.closeDialog();
          if (this.meeting.immediateMeeting) {
            let userData = {
              email: this.$store.state.user.email,
              meetingKey: result.data.meetingKey,
            };

            let saehaUrl = this.getSaehaUrl(this.meeting);

            this.$http.get(saehaUrl, { params: userData }).then((response) => {
              let info = response.data;
              const ds = this.$BodaApp.defaultSettings(info.ds);

              this.$BodaApp.openJoin(
                {
                  roomCode: info.meetingInfo.meetingKey,
                  template: Number(info.oj.template),
                  title: info.meetingInfo.title,
                  userType: info.oj.joinUserType,
                  userId: info.userData.userId,
                  userName: info.userData.userName + `/${info.userData.userId}`,
                  openOption: info.meetingInfo.roomOption
                    ? info.meetingInfo.roomOption
                    : '',
                  joinOption: info.oj.joinOption ? info.oj.joinOption : '',
                },
                () => {
                  this.initMeetingData();
                },
                (errorCode, reason) => {
                  if (
                    errorCode === 'BODA-NOT_INSTALLED' ||
                    errorCode === 'BODA-NOT_CONNECTED_AGENT'
                  ) {
                    this.$BodaApp.downloadClient(
                      {},
                      function () {
                        // 성공 시 처리
                      },
                      function (errorCode, reason) {
                        // 오류 시 처리
                      }
                    );
                  } else if (errorCode === 'BODA-UNDEFINED_ERROR') {
                    if (reason === 'CLIENT_RUNNING') {
                      alert(
                        '영상회의 클라이언트가 이미 실행중입니다. 종료 후 이용해주세요.'
                      );
                    }
                  }
                }
              );
            });
          } else {
            this.initMeetingData();
          }
        }
      });

      return;
    },
    openMeetingConferenceDialog() {
      let startDtime = moment
        .tz(
          this.meeting.startDate + ' ' + this.meeting.startTime,
          moment.tz.guess()
        )
        .utc()
        .format();
      let endDtime = moment
        .tz(
          this.meeting.startDate + ' ' + this.meeting.endTime,
          moment.tz.guess()
        )
        .utc()
        .format();

      this.meeting.startDtime = startDtime;
      this.meeting.endDtime = endDtime;

      this.meetingConferenceDialog.dialog = true;
    },
    closeMeetingConferenceDialog() {
      this.meetingConferenceDialog.dialog = false;
    },
    closeConferenceAgreeDialog() {
      this.conferenceAgreeDialog.dialog = false;
    },
    close(isInit) {
      if (this.$parent.meetingInfo) {
        this.$parent.meetingInfo.selectRoom = null;
      }

      this.selectedConferenceRoom = null;
      this.selectedConferenceRoomArr = [];
      this.allPublicMeeting = false;
      this.immediateMeeting = false;
      // this.initMeeting();
      this.closeDialog(isInit);
      this.initMeeting();
      this.meeting.layoutFixSeatList.selectedLayoutCode = null;
      this.meeting.layoutFixSeatList.selectedLayoutImage = null;
    },
    showDatePicker() {
      if (!this.immediateMeeting) {
        if (this.isActive === 'none') {
          this.isActive = '';
        } else {
          this.isActive = 'none';
        }
      }
    },
    startDateChange() {
      this.isActive = 'none';
      this.editedMeetingInfo.selectStartTime = this.startDate;
    },
    showStartTimePicker() {
      if (this.isActiveStartTime === 'none') {
        this.isActiveStartTime = '';
      } else {
        this.isActiveStartTime = 'none';
      }
    },
    changedstartTime() {
      console.log(`changedstartTime`);
      this.meeting.selectedConferenceRoomArr = [];
      this.meetingConferenceDialog.conferenceRooms = [];
      this.selectedConferenceRoomString = null;
    },
    changedendTime() {
      console.log(`changedendTime`);
      this.meeting.selectedConferenceRoomArr = [];
      this.meetingConferenceDialog.conferenceRooms = [];
      this.selectedConferenceRoomString = null;
    },

    async deleteMeeting() {
      // 미팅 삭제
      let params = {
        meetingKeys: [this.meetingInfo.meetings.meetingKey],
      };
      await this.$http
        .delete('/api/v1/meetings', { params: params })
        .then((response) => {
          if (response.data === 'ok') {
            this.close(true);
            Util.snackBarOpen('회의 삭제 완료', 'success');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectedConferenceRooms(selectedConferenceRooms) {

      console.log(`selectedConferenceRooms`, selectedConferenceRooms)
      let rooms = '';
      this.meeting.selectedConferenceRoomArr = [];
      if (selectedConferenceRooms.length !== 0) {
        this.isDisabled = true; // 회의실 1개라도 있으면 외부망 미팅 X
        this.meetingConferenceDialog.conferenceRooms = selectedConferenceRooms;
        for (let i = 0; i < selectedConferenceRooms.length; i++) {
          this.meeting.roomIds.push(selectedConferenceRooms[i]._id);
          if (i === selectedConferenceRooms.length - 1) {
            rooms += selectedConferenceRooms[i].eqpmt_nm;
          } else {
            rooms += selectedConferenceRooms[i].eqpmt_nm + ', ';
          }
          this.meeting.selectedConferenceRoomArr.push(
            selectedConferenceRooms[i]
          );
        }
        if (this.meeting.selectedConferenceRoomArr.length > 1) {
          if (this.meeting.selectedConferenceRoomArr.length >= 4) {
            this.meeting.conferenceRoomActive = true;
          }
          this.meeting.selectedConferenceRoomString =
            this.meeting.selectedConferenceRoomArr[0].eqpmt_nm +
            '외 ' +
            parseInt(this.meeting.selectedConferenceRoomArr.length - 1) +
            '곳';
        } else {
          this.meeting.selectedConferenceRoomString =
            this.meeting.selectedConferenceRoomArr[0].eqpmt_nm;
        }
      } else {
        this.meeting.conferenceRoomActive = false;
        this.isDisabled = false;
        this.meetingConferenceDialog.conferenceRooms = [];
        this.meeting.selectedConferenceRoomString = null;
      }
    },
    immediateChange(immediate) {
      this.isActive = 'none';
      if (immediate) {
        // 시작 시간 => 즉시로 변경
        // 시작 날짜 => 오늘로 변경
        this.meetingTimeList.unshift(this.$t('page.meeting-reserve.immediate'));

        this.meeting.startTime = this.meetingTimeList[0];
        this.meeting.startDate = moment().format('YYYY.MM.DD');

        let meetingInterval = 10;
        let time = moment();
        let nearestFuture = Util.nearestFutureMinutes(meetingInterval, time);
        this.meeting.endTime = nearestFuture.add(30, 'minutes').format('HH:mm');
      } else {
        this.initTimeData();
        this.isTimeFixed = false;
      }
    },
    deleteConferenceRoom(index) {
      this.selectedConferenceRoomArr.splice(index, 1);
    },
    changeMeetingType() {
      if (this.meetingType === 'general') {
        this.meetingType = 'general';
        this.attendeesString = this.$t('page.meeting-reserve.attendee-list');
      } else {
        this.meetingType = 'article';
        this.attendeesString = this.$t(
          'page.meeting-reserve.attendee-list-type2'
        );
      }
    },
    openMeetingInvitaionDialog() {
      this.meetingInvitaionDialog.dialog = true;
      this.meetingInvitaionDialog.attendees = this.meeting.attendees;
    },
    closeMeetingInvitaionDialog(attendees, exMeeting) {
      if (attendees) {
        if (attendees.length === 1) {
          if (attendees[0].name) {
            this.meeting.attendeesString = `${attendees[0].name}`;
          } else if (attendees[0].email) {
            this.meeting.attendeesString = `${attendees[0].email}`;
          } else {
            this.meeting.attendeesString = `${attendees[0].phone}`;
          }
        } else if (attendees.length > 1) {
          if (attendees[0].name) {
            this.meeting.attendeesString = `${attendees[0].name} 외 ${
              attendees.length - 1
            }명`;
          } else if (attendees[0].email) {
            this.meeting.attendeesString = `${attendees[0].email} 외 ${
              attendees.length - 1
            }명`;
          } else {
            this.meeting.attendeesString = `${attendees[0].phone} 외 ${
              attendees.length - 1
            }명`;
          }
        } else if (attendees.length === 0) {
          this.meeting.attendeesString = null;
        }

        this.meetingInvitaionDialog.dialog = false;
        this.meeting.attendees = attendees;
        this.exMeeting = exMeeting;
      } else {
        this.meetingInvitaionDialog.dialog = false;
        this.meetingInvitaionDialog.attendees = attendees;
        this.meeting.attendees = attendees;
      }
    },
    openMeetingLayoutDialog() {
      /* 레이아웃 설정 */
      if (this.meeting.attendees !== undefined) {
        this.meeting.attendees.forEach((el) => {
          if (!el.name) {
            el['name'] = el.email;
          }
        });

        if (
          this.meeting.conferenceRoomActive &&
          this.meeting.selectedConferenceRoomArr.length >= 1
        ) {
          this.meetingLayoutDialog.attendees = [];
          if (this.meeting.selectedConferenceRoomArr[0] === undefined) {
            alert('영상회의실을 추가해주세요');
            return;
          }
          let concatData = this.meeting.selectedConferenceRoomArr.map((c) => {
            return {
              email: c.deviceId,
              name: c.deviceName,
            };
          });
          this.meeting.attendees = this.meeting.attendees.concat(concatData);
        }

        this.meetingLayoutDialog.dialog = true;
      } else {
        if (
          this.meeting.conferenceRoomActive &&
          this.meeting.selectedConferenceRoomArr.length >= 1
        ) {
          this.meetingLayoutDialog.attendees = [];
          if (this.meeting.selectedConferenceRoomArr[0] === undefined) {
            alert('영상회의실을 추가해주세요');
            return;
          }
          let concatData = this.meeting.selectedConferenceRoomArr.map((c) => {
            return {
              email: c.deviceId,
              name: c.deviceName,
            };
          });
          if (this.meeting.attendees === undefined) {
            this.meeting.attendees = [];
          }
          this.meeting.attendees = this.meeting.attendees.concat(concatData);
        }

        this.meetingLayoutDialog.dialog = true;
      }
    },
    closeMeetingLayoutDialog() {
      this.meetingLayoutDialog.dialog = false;
    },
    selectedFixSeatList(selectedLayoutCode, selectedLayoutImage, fixSeatList) {
      let fixSeatCount = 0;
      // let resultFixSeat = [];

      for (let k = 0; k < fixSeatList.length; k++) {
        if (fixSeatList[k].seat !== null) {
          console.log(fixSeatList[k].seat);
          // resultFixSeat.push(fixSeatList[k].seat.split('#')[0]);
          fixSeatCount++;
        }
      }

      this.isLayout = '';
      this.isInputLayout = 'none';
      this.meeting.layoutFixSeatList.selectedLayoutCode = selectedLayoutCode;
      this.meeting.layoutFixSeatList.selectedLayoutImage = selectedLayoutImage;
      this.meeting.layoutFixSeatList.isLayout = selectedLayoutCode ? true : false;
      
      if (fixSeatCount > 0) {
        this.meeting.layoutFixSeatList.fixSeatList = fixSeatList;
        // this.meeting.resultFixSeat = resultFixSeat;
      }

      if (this.meeting.layoutFixSeatList.selectedLayoutCode === null) {
        this.isInputLayout = '';
        this.isLayout = 'none';
      }

      this.closeMeetingLayoutDialog();
    },
    changeDate(date) {
      this.meeting.selectedConferenceRoomArr = [];
      this.meetingConferenceDialog.conferenceRooms = [];
      this.selectedConferenceRoomString = null;
    },
    getSaehaUrl(meeting) {
      let saehaUrl = '';

      if (!meeting.exMeeting) {
        /* ## 내부망 ## */
        if (meeting.conferenceRoomActive) {
          // 내부망 > CMS미팅
          saehaUrl = '/api/auth/saehaInfo';
        } else {
          // 내부망 > 일반회의
          saehaUrl = '/api/auth/joinUrlForSaehaInfo';
        }
      } else {
        /* ## 외부망 ## */
        if (meeting.conferenceRoomActive) {
          // 외부망 > CMS미팅
          saehaUrl = '/api/auth/dmzSaehaInfo';
        } else {
          // 외부망 > 일반회의
          saehaUrl = '/api/auth/joinUrlForDmzSaehaInfo';
        }
      }

      return saehaUrl;
    },
    async openConferenceRoomsList () {
      this.myWindow = window.open("http://mga.ksd.or.kr:8080/?paramData=eyJwcmdtSWQiOiJNR0FHTTAwNzdQMDMifQ==", "_blank", "width=1400, height=800");
    },
    initMeetingData () {
      // 미팅 데이터 초기화
      this.meeting.creator.email = this.$store.state.user.email;
      this.meeting.creator.empNum = this.$store.state.user.empNum;

      this.meeting.title = null;
      this.meeting.immediateMeeting = false;
      this.meeting.startDate = moment().format('YYYY.MM.DD');
      this.meeting.startTime = null;
      this.meeting.endTime = null;

      this.meeting.attendees = [];
      this.meeting.attendeesString = null;
      this.meeting.conferenceRoomActive = false;
      this.meeting.conferenceRooms = [];
      this.meetingConferenceDialog.conferenceRooms = [];
      
      this.meeting.selectedConferenceRoomArr = [];
      this.meeting.selectedConferenceRoomString = null;

      this.meeting.roomIds = [];

      this.isLayout = 'none';
      this.isInputLayout = '';

      this.meeting.layoutFixSeatList.selectedLayoutCode = null;
      this.meeting.layoutFixSeatList.selectedLayoutImage = null;
      this.meeting.layoutFixSeatList.fixSeatList = [];

      // 선택옵션
      this.meeting.meetingLog = false;
      this.meeting.allPublicMeeting = false;
      this.meeting.meetingPublicType = false;
      this.meeting.password = null;
      this.meeting.exMeeting = false;
      this.isDisabled = false;
    },
  },
};
</script>
<style scoped lang="stylus">
.pop_top{
  font-weight: 600;
}
.input_meeting{
  border:1px solid #d4d4d4;
  width: 100%;
  vertical-align: middle;
  height: 46px;
  display: inline-block;
  line-height: 2em;
  box-sizing: border-box;
  color: #4e4e4e;
  overflow: hidden;
  text-decoration: none;
  text-indent: 10px;
  border-radius:5px;
}

.datetime-start{
  width: 60%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}
.datetime-end{
  width: 39%;
  margin-left: 1%;
  height: 50px;
  border: solid 1px #d4d4d4;
  padding-left: 10px;
  line-height: 50px;
  border-radius: 5px;
  float: left;
}

#startDate1 {
  max-width: 150px;
  margin-right : 15px;
}
.select-items {
  position: absolute;
  background-color: DodgerBlue;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

.meeting-time{
  border: 1px solid #d4d4d4;
  width : 49%;
  height: 46px;
  float: left;
  text-align: center;
  line-height: 46px;
}

.tbw_p01 .active {
  display: '';
}

.tbw_p01 .noActive {
  display: none;
}

.conferenceroom-btn {
  width: max-content;
  padding-right: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 10px;
  background: #fa4242;
  color: white;
  border-radius: 5px;
  z-index: 5;
  position: relative;
  float: left;
}

.conferenceroom-btn p{
  float: left;
  padding-left: 10px;
}
.conferenceroom-btn img{
  float: left;
  cursor: pointer;
  padding-top: 7px;
  padding-left: 3px;
  width: 8px;
}
.pop_tit{
  height: 20px;
  padding: 30px 0 10px;
  color: #444;
  text-align: left;
  letter-spacing: -1px;
  font-size: 25px;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
}
.pop_close{
  position: absolute;
  top: 20px;
  right: 20px;
  display:inline-block;
  width:15px;
  height:15px;
  text-indent: -9999px;
  background: url(/static/webex-cloud/images/common/close_btn.png) center center no-repeat;
}

.popContainer {
  background: #fff;
  font-size: 16px;
  height: 520px;
}

.v-picker{
  position: absolute;
  z-index: 1000;
  top: 45px;
}

.fix-layout-img {
  position: relative;
  width: 70px;
  left: -80px;
  top: 3px;
  cursor:pointer;
}

#bookmarkMeeting{
  text-align: center;
  font-size: 11.5pt;
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  float: right;
  background: #cbe9f8;
  color: #2f66aa;
  border-radius: 5px;
}

#bookmarkAddMeeting{
  width: 130px;
  text-align: center;
  padding: 0;
  font-size: 10pt;
  height: 40px;
  line-height: 40px;
  font-weight: 100;
  position: relative;
  top: -43px;
  left: 175px;
}

.help-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow: auto;
  text-align: center;
}
.help-img{
  width: 100%;
  max-width: 720px;
  display: inline-block;
  position: relative;
  top: 7%;
}
.close-img{
  position: fixed;
  top: 8%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}

.dialog-container {
  width: 100%;
}
.dialog-title .pl-2 {
  font-size: 15px;
  font-weight: 300;
}

#cmsMeeting:after {
  top:21px;
}

#videoMeetingCreateDialog input{
  font-size: 15px !important;
  font-weight: 300 !important;
  color: #1f2e3d;
}

input::placeholder{
  color: #b9b9b9;
  padding-left: 5px;
  font-size: 15px !important;
  font-weight: 100 !important;
  font-family: "Noto Sans KR", sans-serif !important;
}

.custom-label {
  display: flex;
  align-items: center;
}


</style>



// WEBPACK FOOTER //
// src/components/popup/VideoMeetingCreateDialog.vue